const CUSTOMERS_PATH = '/customers';
const APPLICATIONS_PATH = '/applications';

export const UrlsBack = {
  LogInPath1: CUSTOMERS_PATH + '/validate-login',
  LogInPath2: CUSTOMERS_PATH + '/confirm-login',
  SignUpDatosIniciales: CUSTOMERS_PATH + '/validate',
  SignUpValidate: CUSTOMERS_PATH + '/confirm-validate',
  SignUpConfirmCustomer: CUSTOMERS_PATH + '/confirm-customer',
  FixedTerms: CUSTOMERS_PATH + '/fixed-terms',
  FixedTermSimulation: CUSTOMERS_PATH + '/simulate',
  FixedTermCbus: CUSTOMERS_PATH + '/cbus',
  FixedTermCheckAlias: CUSTOMERS_PATH + '/cbu',
  FixedTermNew: CUSTOMERS_PATH + '/new',
  FixedTermConfirm: CUSTOMERS_PATH + '/confirm-fixed-term',
  DebinInfo: CUSTOMERS_PATH + '/debins',
  BankingDays: APPLICATIONS_PATH + '/working-day',
} as const;

export enum UrlsFront {
  LogIn = '/login',
  SignUpHome = '/registro',
  SignUpValidate = '/registro/validar',
  SignUpContact = '/registro/contacto',
  FixedTerms = '/plazofijos',
  FixedTermSimulation = '/plazofijos/simular',
  FixedTermNew = '/plazofijos/alta',
  FixedTermAccept = '/plazofijos/aceptacion',
  DebinConfirm = '/plazofijos/debin',
}

export const HOME_FULL_URL = `${process.env.PUBLIC_URL}${UrlsFront.FixedTerms}`;
